// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import RailsNestedForm from "stimulus-rails-nested-form"

import SubscriptionPlansController from "./subscription_plans_controller"
import SubscriptionFormController from "./subscription_form_controller"
import RegistrationFormController from "./registration_form_controller"
import DropdownController from "./dropdown_controller"
import FilterDropdownController from "./filter_dropdown_controller"
import SidebarController from "./sidebar_controller"
import FiltersController from "./filters_controller"
import PipelineController from "./pipeline_controller"
import RangeFilterController from "./range_filter_controller"
import DateFilterController from "./date_filter_controller"
import MultiFilterController from "./multi_filter_controller"
import TextFilterController from "./text_filter_controller"
import StatePersistenceController from "./state_persistence_controller"
import CsvExportDialogController from "./csv_export_dialog_controller"
import NotificationController from "./notification_controller"
import StatusUpdateController from "./status_update_controller"
import InlineEditController from "./inline_edit_controller"
import RecordDeletionController from "./record_deletion_controller"
import ConfirmationDialogController from "./confirmation_dialog_controller"

application.register("subscription-plans", SubscriptionPlansController)
application.register("subscription-form", SubscriptionFormController)
application.register("registration-form", RegistrationFormController)
application.register("dropdown", DropdownController)
application.register("filter-dropdown", FilterDropdownController)
application.register("sidebar", SidebarController)
application.register("filters", FiltersController)
application.register("pipeline", PipelineController)
application.register("range-filter", RangeFilterController)
application.register("date-filter", DateFilterController)
application.register("multi-filter", MultiFilterController)
application.register("text-filter", TextFilterController)
application.register("state-persistence", StatePersistenceController)
application.register("rails-nested-form", RailsNestedForm)
application.register("csv-export-dialog", CsvExportDialogController)
application.register("notification", NotificationController)
application.register("status-update", StatusUpdateController)
application.register("inline-edit", InlineEditController)
application.register("record-deletion", RecordDeletionController)
application.register("confirmation-dialog", ConfirmationDialogController)
